import React, { useEffect, useState } from "react";
import moment from "moment";
import api from "../../utils/api";
import APIConstant from "../../utils/constant";
import Loader from "components/Shared/Loader/Loader";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { MultiSelect } from "primereact/multiselect";
import { InputTextarea } from "primereact/inputtextarea";
import { InputSwitch } from "primereact/inputswitch";
import cogoToast from "cogo-toast";
import { Calendar } from "primereact/calendar";
import { SelectButton } from "primereact/selectbutton";
import { Checkbox } from "primereact/checkbox";

const reportOptions = [
  { label: "Sales Report", value: "Sales Report" },
  { label: "Price Difference Report", value: "Price Difference Report" },
  { label: "Sales Summary Report", value: "Sales Summary Report" },
  // { label: "Price Difference Summary Report", value: "Price Difference Summary Report" },
  // { label: "Regularity Irregularity Summary Report", value: "Regularity Irregularity Summary Report" },
  {
    label: "Regularity Irregularity Report",
    value: "Regularity Irregularity Report",
  },
];

const frequencyOptions = [
  { label: "Daily", value: "Daily" },
  { label: "Weekly every Sunday", value: "Weekly every Sunday" },
  { label: "Weekly every Monday", value: "Weekly every Monday" },
  { label: "Monthly", value: "Monthly" },
];

const filterDateOptions = ["Today", "7 Days", "30 Days"];

const SalesTypeOptions = [
  { label: "Inter-State", value: "INTERSTATE" },
  { label: "Intra-State", value: "INTRA-STATE" },
];

const BusinessTypeOptions = [
  { label: "B2B", value: "B2B" },
  { label: "B2C", value: "B2C" },
];

const PaymentTypeOptions = [
  { label: "Upfront", value: "Upfront Payment" },
  { label: "Credit", value: "Credit" },
];

const limitTypeList = [
  { label: "Low Limit", value: "LowLimit" },
  { label: "Ideal Limit", value: "IdealLimit" },
  { label: "High Limit", value: "HighLimit" },
];

const AddScheduleReport = (props) => {
  const [userId, setUserId] = useState(null);
  const [scheduleData, setScheduleData] = useState({
    ReportType: "",
    Filters: {
      FilterDate: "Today", // Default to Today
      FromDate: [new Date(), new Date()], // Set initial range for Today
      IsGst: null,
      IsInclusive: null,
      Payment: [],
      SalesType: [],
      BusinessType: [],
      PaymentMode: [],
      Item: [],
      Customer: [],
      Supplier: [],
      LimitType: "IdealLimit",
    },
    Frequency: "",
    TimeOfDay: "",
    ReportFormat: "CSV",
    EmailTo: "",
    EmailSubject: "",
    EmailBody: "",
    IsActive: true,
    SendVia: ["Email"],
  });

  // Dropdown lists
  const [variantList, setVariantList] = useState([]);
  const [customerList, setCustomerList] = useState([]);
  const [supplierList, setSupplierList] = useState([]);
  const [paymentModeList, setPaymentModeList] = useState([]);

  useEffect(() => {
    const uid = localStorage.getItem("Infodata");
    setUserId(uid);
    getVariants(uid);
    getCustomers(uid);
    getSuppliers(uid);
    getPaymentModes(uid);

    if (props.location.state && props.location.state.scheduleId) {
      getScheduleById(props.location.state.scheduleId);
    }
  }, []);

  const getScheduleById = async (id) => {
    try {
      Loader.show();
      const res = await api.post(APIConstant.path.GetScheduleReportById, {
        ScheduleId: id,
      });
      if (res.Success === 1) {
        let tempData = res.Data;
        if (tempData.Filters.FromDate && tempData.Filters.FromDate.length) {
          tempData.Filters.FromDate = [
            new Date(tempData.Filters.FromDate[0]),
            new Date(tempData.Filters.FromDate[1]),
          ];
        }
        setScheduleData(res.Data);
      } else {
        cogoToast.error(res.Message);
        props.history.push("/admin/schedule-report");
      }
    } catch (err) {
      console.log(err);
    } finally {
      Loader.hide();
    }
  };

  useEffect(() => {
    if (!scheduleData.Filters.FilterDate) return;

    const today = moment();
    let range = null;

    if (scheduleData.Filters.FilterDate === "Today") {
      range = [
        today
          .clone()
          .startOf("day")
          .toDate(),
        today
          .clone()
          .endOf("day")
          .toDate(),
      ];
    } else if (scheduleData.Filters.FilterDate === "7 Days") {
      range = [
        moment()
          .subtract(6, "days")
          .startOf("day")
          .toDate(),
        today
          .clone()
          .endOf("day")
          .toDate(),
      ];
    } else if (scheduleData.Filters.FilterDate === "30 Days") {
      range = [
        moment()
          .subtract(29, "days")
          .startOf("day")
          .toDate(),
        today
          .clone()
          .endOf("day")
          .toDate(),
      ];
    }

    if (range) {
      setScheduleData((prev) => ({
        ...prev,
        Filters: { ...prev.Filters, FromDate: range },
      }));
    }
  }, [scheduleData.Filters.FilterDate]);

  /* ================= DROPDOWNS ================= */
  const getVariants = async (UserId) => {
    const res = await api.post(APIConstant.path.GetVariantList, { UserId });
    if (res.Success === 1) setVariantList(res.Data);
  };

  const getCustomers = async (UserId) => {
    const res = await api.post(APIConstant.path.GetNetworkByUserType, {
      UserId,
      UserType: "Customer",
    });
    if (res.Success === 1) setCustomerList(res.Data);
  };

  const getSuppliers = async (UserId) => {
    const res = await api.post(APIConstant.path.GetNetworkByUserType, {
      UserId,
      UserType: "Supplier",
    });
    if (res.Success === 1) setSupplierList(res.Data);
  };

  const getPaymentModes = async (UserId) => {
    const res = await api.post(APIConstant.path.GetPaymentModeMaster, {
      UserId,
    });
    if (res.Success === 1) setPaymentModeList(res.Data || []);
  };

  const handleSave = async () => {
    if (
      !scheduleData.ReportType ||
      !scheduleData.Frequency ||
      !scheduleData.TimeOfDay
    ) {
      cogoToast.error("Please fill all required fields (*)");
      return;
    }

    if (scheduleData.SendVia.length === 0) {
      cogoToast.error(
        "Please select at least one delivery method (Email/Notification)."
      );
      return;
    }

    if (scheduleData.SendVia.includes("Email") && !scheduleData.EmailTo) {
      cogoToast.error("Please provide an email address for email delivery.");
      return;
    }

    try {
      Loader.show();
      const payload = {
        ...scheduleData,
        UserId: userId,
        ScheduleId: scheduleData._id,
      };
      const res = await api.post(
        APIConstant.path.AddUpdateScheduleReport,
        payload
      );
      if (res.Success === 1) {
        cogoToast.success(res.Message);
        props.history.push("/admin/schedule-report");
      } else {
        cogoToast.error(res.Message);
      }
      Loader.hide();
    } catch (err) {
      console.log(err);
      Loader.hide();
    }
  };

  const onSendViaChange = (e) => {
    let selectedSendVia = [...scheduleData.SendVia];

    if (e.checked) {
      selectedSendVia.push(e.value);
    } else {
      selectedSendVia = selectedSendVia.filter((value) => value !== e.value);
    }

    setScheduleData({ ...scheduleData, SendVia: selectedSendVia });
  };

  const renderFilters = () => {
    switch (scheduleData.ReportType) {
      case "Sales Report":
        return (
          <>
            <div className="p-col-12 p-md-6">
              <div className="custom-inputs">
                <label>GST</label>
                <SelectButton
                  value={scheduleData.Filters.IsGst}
                  options={[
                    { label: "GST", value: true },
                    { label: "Non GST", value: false },
                  ]}
                  onChange={(e) =>
                    setScheduleData({
                      ...scheduleData,
                      Filters: { ...scheduleData.Filters, IsGst: e.value },
                    })
                  }
                />
              </div>
            </div>
            <div className="p-col-12 p-md-6">
              <div className="custom-inputs">
                <label>Inclusive</label>
                <SelectButton
                  value={scheduleData.Filters.IsInclusive}
                  options={[
                    { label: "Inclusive", value: true },
                    { label: "Exclusive", value: false },
                  ]}
                  onChange={(e) =>
                    setScheduleData({
                      ...scheduleData,
                      Filters: {
                        ...scheduleData.Filters,
                        IsInclusive: e.value,
                      },
                    })
                  }
                />
              </div>
            </div>
            <div className="p-col-12 p-md-6">
              <div className="custom-inputs">
                <label>Payment Type</label>
                <MultiSelect
                  value={scheduleData.Filters.Payment}
                  p
                  options={PaymentTypeOptions}
                  onChange={(e) =>
                    setScheduleData({
                      ...scheduleData,
                      Filters: { ...scheduleData.Filters, Payment: e.value },
                    })
                  }
                  placeholder="Select Payment Type"
                  display="chip"
                  className="p-w-100"
                />
              </div>
            </div>
            <div className="p-col-12 p-md-6">
              <div className="custom-inputs">
                <label>Sales Type</label>
                <MultiSelect
                  value={scheduleData.Filters.SalesType}
                  options={SalesTypeOptions}
                  onChange={(e) =>
                    setScheduleData({
                      ...scheduleData,
                      Filters: { ...scheduleData.Filters, SalesType: e.value },
                    })
                  }
                  placeholder="Select Sales Type"
                  display="chip"
                  className="p-w-100"
                />
              </div>
            </div>
            <div className="p-col-12 p-md-6">
              <div className="custom-inputs">
                <label>Business Type</label>
                <MultiSelect
                  value={scheduleData.Filters.BusinessType}
                  options={BusinessTypeOptions}
                  onChange={(e) =>
                    setScheduleData({
                      ...scheduleData,
                      Filters: {
                        ...scheduleData.Filters,
                        BusinessType: e.value,
                      },
                    })
                  }
                  placeholder="Select Business Type"
                  display="chip"
                  className="p-w-100"
                />
              </div>
            </div>
            <div className="p-col-12 p-md-6">
              <div className="custom-inputs">
                <label>Payment Mode</label>
                <MultiSelect
                  value={scheduleData.Filters.PaymentMode}
                  options={paymentModeList}
                  onChange={(e) =>
                    setScheduleData({
                      ...scheduleData,
                      Filters: {
                        ...scheduleData.Filters,
                        PaymentMode: e.value,
                      },
                    })
                  }
                  placeholder="Select Payment Mode"
                  display="chip"
                  className="p-w-100"
                />
              </div>
            </div>
            <div className="p-col-12 p-md-6">
              <div className="custom-inputs">
                <label>Variants</label>
                <MultiSelect
                  value={scheduleData.Filters.Item} // To avoid null/undefined issues
                  options={variantList}
                  onChange={(e) =>
                    setScheduleData({
                      ...scheduleData,
                      Filters: { ...scheduleData.Filters, Item: e.value },
                    })
                  }
                  placeholder="Select Variants"
                  display="chip"
                  filter
                  className="p-w-100"
                />
              </div>
            </div>
            <div className="p-col-12 p-md-6">
              <div className="custom-inputs">
                <label>Customer</label>
                <MultiSelect
                  value={scheduleData.Filters.Customer}
                  options={customerList}
                  onChange={(e) =>
                    setScheduleData({
                      ...scheduleData,
                      Filters: { ...scheduleData.Filters, Customer: e.value },
                    })
                  }
                  placeholder="Select Customer"
                  display="chip"
                  filter
                  className="p-w-100"
                />
              </div>
            </div>
          </>
        );
      case "Price Difference Report":
        return (
          <>
            <div className="p-col-12 p-md-6">
              <div className="custom-inputs">
                <label>Items</label>
                <MultiSelect
                  value={scheduleData.Filters.Item}
                  options={variantList}
                  onChange={(e) =>
                    setScheduleData({
                      ...scheduleData,
                      Filters: { ...scheduleData.Filters, Item: e.value },
                    })
                  }
                  placeholder="Select Items"
                  display="chip"
                  filter
                  className="p-w-100"
                />
              </div>
            </div>
            <div className="p-col-12 p-md-6">
              <div className="custom-inputs">
                <label>Supplier</label>
                <MultiSelect
                  value={scheduleData.Filters.Supplier}
                  options={supplierList}
                  onChange={(e) =>
                    setScheduleData({
                      ...scheduleData,
                      Filters: { ...scheduleData.Filters, Supplier: e.value },
                    })
                  }
                  placeholder="Select Supplier"
                  display="chip"
                  filter
                  className="p-w-100"
                />
              </div>
            </div>
          </>
        );
      case "Regularity Irregularity Report":
        return (
          <>
            <div className="p-col-12 p-md-6">
              <div className="custom-inputs">
                <label>Items</label>
                <MultiSelect
                  value={scheduleData.Filters.Item}
                  options={variantList}
                  optionLabel="label"
                  onChange={(e) =>
                    setScheduleData({
                      ...scheduleData,
                      Filters: { ...scheduleData.Filters, Item: e.value },
                    })
                  }
                  placeholder="Select Items"
                  display="chip"
                  filter
                  className="p-w-100"
                />
              </div>
            </div>
            <div className="p-col-12 p-md-6">
              <div className="custom-inputs">
                <label>Limit Type</label>
                <Dropdown
                  value={scheduleData.Filters.LimitType}
                  options={limitTypeList}
                  onChange={(e) =>
                    setScheduleData({
                      ...scheduleData,
                      Filters: { ...scheduleData.Filters, LimitType: e.value },
                    })
                  }
                  placeholder="Select Limit Type"
                  className="p-w-100"
                />
              </div>
            </div>
          </>
        );
      default:
        return null;
    }
  };

  return (
    <div className="wayment-owner-dashboard e-weighment-dashoard e-inward-body">
      <div className="heading-area p-d-flex p-ai-center p-jc-between">
        <div
          className="ship-heading-area p-d-flex p-ai-center"
          onClick={() => props.history.push("/admin/schedule-report")}
        >
          <i className="pi pi-arrow-right rotate" />
          <h2>
            {scheduleData._id ? "Edit Schedule Report" : "Add Schedule Report"}
          </h2>
        </div>
      </div>
      <hr />
      <div className="container-body e-container-body">
        <div className="conatiner-tab-body p-mt-3 p-mx-1 e-view-card">
          <div className="p-grid p-fluid">
            {/* Report Selection */}
            <div className="p-col-12 p-md-6">
              <div className="custom-inputs">
                <label>Select Report *</label>
                <Dropdown
                  value={scheduleData.ReportType}
                  options={reportOptions}
                  onChange={(e) =>
                    setScheduleData({ ...scheduleData, ReportType: e.value })
                  }
                  placeholder="Select Report"
                />
              </div>
            </div>

            <div className="p-col-12 p-md-6" />

            {/* Dynamic Filters */}
            {scheduleData.ReportType && (
              <>
                <div className="p-col-12">
                  <h4 className="p-my-3">Filters</h4>
                </div>
                {/* <div className="p-col-6 p-md-6">
                  <div className="custom-inputs">
                    <label>Date Range</label>
                    <div className="p-d-flex p-ai-center">
                      <SelectButton
                        value={scheduleData.Filters.FilterDate}
                        options={filterDateOptions}
                        onChange={(e) => {
                          setScheduleData((prev) => ({
                            ...prev,
                            Filters: {
                              ...prev.Filters,
                              FilterDate: e.value,
                            },
                          }));
                        }}
                        className="p-mr-2"
                      />
                      <Calendar
                        value={scheduleData.Filters.FromDate}
                        onChange={(e) =>
                          setScheduleData((prev) => ({
                            ...prev,
                            Filters: {
                              ...prev.Filters,
                              FromDate: e.value,
                              FilterDate: null,
                            },
                          }))
                        }
                        selectionMode="range"
                        placeholder="Or select a custom range"
                        dateFormat="dd/mm/yy"
                        className="p-w-100"
                      />
                    </div>
                  </div>
                </div> */}
                {renderFilters()}
              </>
            )}

            {/* Schedule Section */}
            <div className="p-col-12">
              <h4 className="p-my-3">Report Schedule</h4>
            </div>
            <div className="p-col-12 p-md-6">
              <div className="custom-inputs">
                <label>Frequency *</label>
                <Dropdown
                  value={scheduleData.Frequency}
                  options={frequencyOptions}
                  onChange={(e) =>
                    setScheduleData({ ...scheduleData, Frequency: e.value })
                  }
                  placeholder="Select Frequency"
                />
              </div>
            </div>
            <div className="p-col-12 p-md-6">
              <div className="custom-inputs">
                <label>Time of Day *</label>
                <InputText
                  type="time"
                  value={scheduleData.TimeOfDay}
                  onChange={(e) =>
                    setScheduleData({
                      ...scheduleData,
                      TimeOfDay: e.target.value,
                    })
                  }
                />
              </div>
            </div>
            <div className="p-col-12 p-md-6">
              <div className="custom-inputs">
                <label>Report Format</label>
                <Dropdown
                  value={scheduleData.ReportFormat}
                  options={[{ label: "CSV", value: "CSV" }]}
                  onChange={(e) =>
                    setScheduleData({ ...scheduleData, ReportFormat: e.value })
                  }
                  placeholder="Select Format"
                  disabled
                />
              </div>
            </div>

            {/* Email Options */}
            <div className="p-col-12">
              <h4 className="p-my-3">Email Options</h4>
            </div>
            <div className="p-col-12 p-md-6">
              <div className="custom-inputs">
                <label>Send Via *</label>
                <div className="p-d-flex p-ai-center p-pt-2">
                  <div className="p-field-checkbox p-mr-3">
                    <Checkbox
                      inputId="send_email"
                      value="Email"
                      onChange={onSendViaChange}
                      checked={scheduleData.SendVia.includes("Email")}
                    />
                    <label htmlFor="send_email" className="p-ml-2">
                      Email
                    </label>
                  </div>
                  <div className="p-field-checkbox">
                    <Checkbox
                      inputId="send_notification"
                      value="Notification"
                      onChange={onSendViaChange}
                      checked={scheduleData.SendVia.includes("Notification")}
                    />
                    <label htmlFor="send_notification" className="p-ml-2">
                      Notification
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div className="p-col-12 p-md-6" />
            <div className="p-col-12 p-md-6">
              <div className="custom-inputs">
                <label>Send Email to *</label>
                <InputText
                  value={scheduleData.EmailTo}
                  onChange={(e) =>
                    setScheduleData({
                      ...scheduleData,
                      EmailTo: e.target.value,
                    })
                  }
                  placeholder="Enter email address"
                  disabled={!scheduleData.SendVia.includes("Email")}
                />
              </div>
            </div>
            <div className="p-col-12 p-md-6">
              <div className="custom-inputs">
                <label>Email Subject Line (Optional)</label>
                <InputText
                  value={scheduleData.EmailSubject}
                  onChange={(e) =>
                    setScheduleData({
                      ...scheduleData,
                      EmailSubject: e.target.value,
                    })
                  }
                  placeholder="Enter subject"
                  disabled={!scheduleData.SendVia.includes("Email")}
                />
              </div>
            </div>
            <div className="p-col-12">
              <div className="custom-inputs">
                <label>Email Body (Optional)</label>
                <InputTextarea
                  value={scheduleData.EmailBody}
                  onChange={(e) =>
                    setScheduleData({
                      ...scheduleData,
                      EmailBody: e.target.value,
                    })
                  }
                  rows={3}
                  placeholder="Enter email body"
                  disabled={!scheduleData.SendVia.includes("Email")}
                />
              </div>
            </div>

            {/* Active Toggle */}
            <div className="p-col-12">
              <div className="p-d-flex p-ai-center">
                <InputSwitch
                  checked={scheduleData.IsActive}
                  onChange={(e) =>
                    setScheduleData({ ...scheduleData, IsActive: e.value })
                  }
                />
                <label className="p-ml-2">Active</label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="p-d-flex p-ai-center p-jc-start e-inward-footer">
        <button
          className="secondary-btn"
          onClick={() => props.history.push("/admin/schedule-report")}
        >
          Cancel
        </button>
        <Button
          label={scheduleData._id ? "Update" : "Save"}
          className="primary-btn color-white p-ml-2"
          onClick={handleSave}
        />
      </div>
    </div>
  );
};

export default AddScheduleReport;
